module.exports = __webpack_public_path__ + "img/product_11.634a335.webp";